enum TECH_ASSISTANT_KEYS {
  aiAssistant = 'aiAssistant',
  evaluations = 'evaluations',
  conversationLogs = 'conversationLogs',
}

const TECH_ASSISTANT_NAMES: { [section in TECH_ASSISTANT_KEYS]: string } = {
  aiAssistant: 'AI Assistant',
  evaluations: 'Evaluations',
  conversationLogs: 'Conversation Logs',
}

const TECH_ASSISTANT_PATHS: { [section in TECH_ASSISTANT_KEYS]: string } = {
  aiAssistant: '/technician-assistant/ai-assistant',
  evaluations: '/technician-assistant/evaluations',
  conversationLogs: '/technician-assistant/conversation-logs',
}

export { TECH_ASSISTANT_KEYS, TECH_ASSISTANT_NAMES, TECH_ASSISTANT_PATHS }
